/* import __COLOCATED_TEMPLATE__ from './tab.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

import type { BvBtnArgs } from '../bv-btn/index';

import type { THue } from 'volta/utils/style-utils';

interface BvTabsTabArgs extends Omit<BvBtnArgs, 'onClick'> {
  expand?: boolean;
  focusFn?: (id?: string) => void;
  onClick?: (id: string, event?: Event) => void;
  id?: string;
  selectedTab?: string;
  disabled?: boolean;
  iconLeftColor?: THue;
  iconRightColor?: THue;
}

export interface BvTabsTabSignature {
  Args: BvTabsTabArgs;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvTabsTabComponent = templateOnlyComponent<BvTabsTabSignature>();

export default BvTabsTabComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvTabs::Tab': typeof BvTabsTabComponent;
    'bv-tabs/tab': typeof BvTabsTabComponent;
  }
}
